import React from "react";
import "./index.css";
import infoIcon from "../../../../../assets/design-revamp-company/company-epr/info-icon.svg";
import storage from "../../../../../assets/design-revamp-company/company-epr/Storage.svg";

const FinishModal = ({ onClose, onClick }) => {
  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content-base">
        <div className="modal-qa">
          <div className="modal-qa-title">Tip</div>
          <div className="modal-qa-content">
            <div className="modal-qa-texts">
              <p style={{ marginBottom: "23.8px" }}>
                Now your invoices have been imported to your calculation flow.
                You can see this by clicking your location and scroll down
                through the flow.
              </p>
            </div>
            <div className="modal-qa-btn" onClick={onClick}>
              <p>Ok, great!</p>
              <img src={infoIcon} alt="Info Icon" width={25} height={25} />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "31px",
              }}
              onClick={onClick}
            >
              <img
                src={storage}
                alt="Go to company page"
                width={159}
                height={170}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinishModal;
